import { useAuth } from 'oidc-react';
import * as React from 'react';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import { setAuthResponse, setRole, UserRole } from '../store/auth';
import Logo from '../components/Logo';
import { ProgressSpinner } from 'primereact/progressspinner';
import UserMenu from '../components/auth/UserMenu';
import Nav from '../components/Nav';
import { useAppDispatch, useAppSelector } from '../store';
import { setCurrentPeriod } from '../store/ui';
import { getLastUpdatedTimestamp } from '../store/upload';
import { Dropdown } from 'primereact/dropdown';
import { authIsEnabled } from '../utils/auth';

function Root() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { userData } = authIsEnabled() ? useAuth() : {};
  const { isAuthorized, role } = useAppSelector((state) => state.auth);
  const [hasAuthTimeoutError, setHasAuthTimeoutError] = React.useState<boolean>(false);

  if (userData) {
    dispatch(setAuthResponse(userData));
  }
  dispatch(setCurrentPeriod(new Date()));
  
  React.useEffect(() => {
    if (!isAuthorized) {
      navigate('/unauthorized', { replace: true } );
    }
    dispatch(getLastUpdatedTimestamp());
  }, [isAuthorized])
  
  if (!userData && authIsEnabled()) {
    setTimeout(() => {
      setHasAuthTimeoutError(true);
    }, 10000);

    return (
      <div className="fixed inset-0 flex flex-col items-center justify-center text-white bg-allstate-navy">
        <div className="absolute top-6 left-4">
          <Logo className="text-white w-[100px]" />
        </div>

        <div className="flex flex-col gap-2 text-center">
          {hasAuthTimeoutError && (
            <p className="text-lg">An error occurred while trying to log you in. Please refresh and try again</p>
          )}
          {!hasAuthTimeoutError && (
            <>
              <ProgressSpinner className="w-8 h-8" strokeWidth="4" />
              <p className="text-lg">Logging you in<span className="absolute">...</span></p>
            </>
          )}
        </div>
      </div>
    )
  }

  return (
    <>
      <main className="grid grid-cols-[auto_1fr] min-h-screen">
        <aside className="py-6 bg-white">
          <div className="sticky top-6">
            <div className="px-4">
              <Link to="/">
                <Logo className="text-allstate-navy" />
              </Link>
            </div>
            <div className="mt-4">
              <Nav />
            </div>
          </div>
        </aside>
        <section className="flex flex-col gap-8 p-5">
          <div id="data-top-notification" className="sticky top-0 z-50 flex-1 -mx-5 -mt-5 empty:hidden"></div>
          <div className="self-end">
            <UserMenu />
          </div>

          <div className="flex flex-col gap-4 flex-1 max-w-[800px] w-full mx-auto">
            <section className="min-h-full">            
              <Outlet />
            </section>
          </div>

          <div className=" text-grey-8 leading-[25px] max-w-[1160px]">
            <p>
              The Self-Funded Program through Nationwide provides tools for employers owning small to
              midsized businesses to establish a self-funded health benefit plan for their employees. The
              benefit plan is established by the employer and is not an insurance product. Stop loss insurance
              policies are underwritten by Nationwide Life and Benefits Insurance Company, Columbus OH, in AK,
              AR, AZ, CT, IL, MA, PA, TX, WI; Integon National Insurance Company in NY; and National Health
              Insurance Company in CO, WA and all other states where offered. Product availability and specific
              provisions may vary by state.
            </p>
            <p>
              At Nationwide, we work hard to ensure your online safety, security and privacy.
              Please take a moment to <a
                class="[ text-grey-8 underline ]"
                href="https://www.nationwide.com/personal/privacy-security/"
                target="_blank"
              >review our policies</a>.
            </p>
            <p>
              Nationwide and the Nationwide N and Eagle are service marks of Nationwide Mutual Insurance Company.
              &copy;{new Date().getFullYear()} Nationwide
            </p> 
          </div>
        </section>
      </main>

      {!authIsEnabled() && (
        <div className="fixed bottom-0 right-0 flex items-center gap-2 px-4 py-2 bg-white border rounded-tl">
          <label className="font-bold">Set user role:</label>
          <Dropdown options={[UserRole.ACTUARY, UserRole.ACCOUNT_MANAGER]} value={role} onChange={(e) => dispatch(setRole(e.value))} />
        </div>
      )}
    </>
  )
}

export default Root;